module.exports = __webpack_public_path__ + "img/social_linkedin.49a2466e.svg";